import type { ReactNode, FC } from 'react';
import cn from 'classnames';
import { sanitizeHref } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import SmallArrowRight from '@wix/da-ds/pkg/Icons/12x12/ArrowRight';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './Breadcrumbs.scss';

export const BreadcrumbsLayout: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={s['breadcrumbs']}>{children}</div>
);

export const BreadcrumbsItem: FC<{
  href?: string;
  biData?: any;
  label: string;
  isRoot?: boolean;
}> = ({ href, biData, label, isRoot }) => (
  <PlainButtonOrLink
    className={cn(s['breadcrumb'], isRoot && s['root-breadcrumb'])}
    href={sanitizeHref(href)}
    biData={biData}
  >
    {label}
  </PlainButtonOrLink>
);

export const BreadcrumbsSeparator: FC<{ isMobile?: boolean }> = ({ isMobile }) =>
  isMobile ? (
    <SmallArrowRight className={s['breadcrumb-separator']} size={IconSize.TINY} />
  ) : (
    <ArrowRight className={s['breadcrumb-separator']} size={IconSize.COMPACT} />
  );
